import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { ComponentsModule } from '../components/components.module';
import { SharedModule } from '../shared/shared.module';

import { PresentationNameDirective } from './directives/presentation-name.directive';
import { PresentationPreviewComponent } from './components/presentation-preview/presentation-preview.component';
import { PresentationSelectorModalComponent } from './components/presentation-selector-modal/presentation-selector-modal.component';
import { PresentationMultiSelectorComponent } from './components/presentation-multi-selector/presentation-multi-selector.component';
import { FolderPathComponent } from '../components/folders/folder-path/folder-path.component';
import { StatusBadgeComponent } from '../components/status-badge/status-badge.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    SharedModule,
    FormsModule,
    MatDialogModule,
    MatCheckboxModule,
    MatButtonModule,
    FolderPathComponent,
    StatusBadgeComponent,
  ],
  declarations: [
    PresentationNameDirective,
    PresentationPreviewComponent,
    PresentationSelectorModalComponent,
    PresentationMultiSelectorComponent,
  ],
  exports: [
    PresentationNameDirective,
    PresentationPreviewComponent,
    PresentationSelectorModalComponent,
    PresentationMultiSelectorComponent,
  ],
})
export class PresentationsModule {}
